import "./QASection.css";

import React, { useState, useEffect } from "react";
import Footer from "../../Footer";
import { useNavigate } from "react-router-dom";

const qaDataPlanned = [
  {
    id: "step",
    header: "기획 출판의 이해"
  },
  {
    id: "q1",
    question: "기획 출판이란 무엇인가요?",
    answer: `기획 출판은 출판사가 출간 비용과 판매 리스크를 부담하고, 책의 기획부터 편집·디자인·제작·유통·마케팅까지 전 과정을 주도하는 방식입니다. 
            저자에게는 계약에서 정한 기준에 따라 인세가 지급됩니다.`
  },
  {
    id: "q2",
    question: "기획 출판은 자비 출판·반기획 출판과 어떻게 다른가요?",
    answer: `기획 출판은 출판사가 출간 비용과 판매 리스크를 부담한다는 점에서 자비 출판·반기획 출판과 차이가 있습니다.

            • 자비 출판 : 저자가 출간 비용을 부담하고, 출판사는 편집·디자인·제작·유통·정산 등 출간 과정을 지원합니다.
            • 반기획 출판 : 저자와 출판사가 출간 비용, 제작 역할, 유통·마케팅 범위 등을 협의해 분담합니다.
            • 기획 출판 : 출판사가 출간 비용과 판매 리스크를 부담하고, 기획부터 편집·제작·유통·마케팅까지 전 과정을 주도합니다.

            기획 출판은 출판사의 검토와 선정 과정을 거쳐 진행되며, 모든 원고가 출간 대상이 되는 것은 아닙니다.`
  },
  {
    id: "q3",
    question: "기획 출판은 저자가 비용을 부담하지 않나요?",
    answer: `일반적으로 기획 출판은 출판사가 편집, 디자인, 제작, 유통, 마케팅 등 출간에 필요한 주요 비용을 부담합니다. 
            저자는 별도의 출간 제작비를 부담하지 않으며, 도서 판매에 따라 계약에서 정한 기준의 인세를 지급받습니다.`
  },
  
  {
    id: "step",
    header: "출간 준비 및 검토"
  },
  {
    id: "q4",
    question: "어떤 저자나 원고가 기획 출판 검토 대상이 되나요?",
    answer: `특정 분야의 전문 지식이나 경험을 갖춘 저자, 독자에게 분명한 효용을 줄 수 있는 원고, 기존 시장과 차별화된 관점이나 구성을 가진 원고가 기획 출판 검토 대상이 될 수 있습니다. 저자의 전문성, 활동 이력, 독자와의 접점도 함께 고려됩니다.`
  },
  {
    id: "q7",
    question: "기획 출판 제안은 어떻게 하나요?",
    answer: `기획 출판 제안은 도서 기획안, 목차, 샘플 원고, 저자 소개 자료를 준비해 출판사에 전달하는 방식으로 진행할 수 있습니다. 
            제안 자료에는 책의 주제, 기획 의도, 예상 독자층, 경쟁 도서와의 차별점, 저자의 전문성, 홍보 가능성 등이 포함되면 좋습니다.`
  },
  {
    id: "q8",
    question: "출판사는 어떤 기준으로 검토하나요?",
    answer: `출판사는 원고의 주제, 시장성, 독자층, 차별성, 완성도, 제작 난이도, 판매 가능성, 출판사의 출간 방향과의 적합성을 종합적으로 검토합니다. 
            기획 출판은 출판사가 비용과 리스크를 부담하는 방식이므로 모든 원고가 출간 대상이 되는 것은 아닙니다.`
  },
  {
    id: "q9",
    question: "원고가 완성되지 않아도 제안할 수 있나요?",
    answer: `가능합니다. 다만 원고가 완성되지 않은 경우에는 기획안, 목차, 샘플 원고, 저자 이력, 집필 계획이 중요합니다. 
            출판사는 해당 자료를 바탕으로 출간 가능성과 집필 진행 가능성을 검토합니다.`
  },
  {
    id: "q10",
    question: "검토 결과는 어떻게 안내되나요?",
    answer: `검토 결과는 출판사의 내부 검토 일정과 원고 성격에 따라 안내됩니다. 
            출간이 어렵다고 판단되는 경우에는 원고 보완 방향이나 다른 출판 방식에 대한 의견을 안내드릴 수 있습니다.`
  },
  {
    id: "step",
    header: "비용 및 계약 조건"
  },
  {
    id: "q11",
    question: "기획 출판 계약에서는 무엇을 정하나요?",
    answer: `기획 출판 계약에서는 출판권의 범위, 계약 기간, 인세 기준, 정산 주기, 원고 제출 일정, 편집 및 제작 일정, 2차 저작물 권리, 계약 해지 조건 등을 정합니다. 
            계약 전에는 권리 범위와 정산 기준을 충분히 확인하는 것이 중요합니다.`
  },
  {
    id: "q12",
    question: "인세는 어떻게 지급되나요?",
    answer: `인세는 계약에서 정한 기준에 따라 지급됩니다. 일반적으로 도서 판매량 또는 판매 정산 자료를 기준으로 일정 주기마다 정산합니다. 
            구체적인 인세 기준, 지급 주기, 선급금 여부 등은 도서의 성격과 계약 조건에 따라 달라질 수 있습니다.`
  },
  {
    id: "q13",
    question: "선급금이 항상 지급되나요?",
    answer: `선급금은 모든 계약에서 지급되는 것은 아닙니다.
             저자의 이력, 원고의 시장성, 출판사의 판단, 계약 조건에 따라 지급 여부와 금액이 달라질 수 있습니다.`
  },
  {
    id: "q14",
    question: "저자가 추가 비용을 부담하는 경우도 있나요?",
    answer: `일반적인 기획 출판에서는 출판사가 주요 제작비를 부담하므로, 저자가 별도의 출간 제작비를 부담하지 않습니다. 
            다만 저자가 특별히 요청하는 별도 제작물, 추가 홍보, 특수 자료 제작 등은 계약 조건에 따라 별도 협의가 필요할 수 있습니다.`
  },
  
  {
    id: "step",
    header: "기획·편집·디자인 및 출간 과정"
  },
  {
    id: "q16",
    question: "기획 과정은 어떻게 진행되나요?",
    answer: `기획 출판에서는 출판사가 도서의 시장성, 독자층, 콘셉트, 목차, 제목, 판매 포지션 등을 검토하며 기획 방향을 제안합니다. 
            다만 책의 전문성과 메시지는 저자의 지식과 경험에서 나오므로, 저자와 출판사가 긴밀히 협의하며 기획을 구체화합니다.`
  },
  {
    id: "q17",
    question: "편집 과정에서 저자의 역할은 무엇인가요?",
    answer: `저자는 원고 집필, 자료 제공, 편집자의 수정 제안 검토, 사실 확인, 최종 교정 확인 등에 참여합니다. 
            출판사는 원고의 구조, 문장, 독자 전달력, 상품성 등을 고려해 편집 방향을 제안하며, 저자와 협의해 원고의 완성도를 높여갑니다.`
  },
  {
    id: "q18",
    question: "편집 방향은 어떻게 정하나요?",
    answer: `편집 방향은 원고의 주제, 독자층, 출간 목적, 시장성을 함께 고려해 정합니다. 
            출판사는 원고의 구성, 문장, 제목, 분량, 디자인 방향 등에 대해 제안할 수 있으며, 
            원고의 핵심 내용과 저자의 전문성이 필요한 부분은 충분히 협의해 진행합니다.`
  },
  {
    id: "q19",
    question: "표지와 본문 디자인은 어떻게 정해지나요?",
    answer: `표지와 본문 디자인은 출판사가 도서의 콘셉트, 독자층, 시장 포지션을 고려해 진행합니다. 
            저자의 의견도 참고할 수 있으며, 최종 디자인 방향은 도서의 성격, 제작 조건, 마케팅 방향 등을 종합적으로 고려해 정합니다.`
  },
  {
    id: "q20",
    question: "제작 과정은 어떻게 진행되나요?",
    answer: `기획 출판 도서는 기획 확정, 원고 집필 및 편집, 디자인 방향 확정, 본문 조판, 교정, 최종 파일 확정, 종이책 인쇄 또는 전자책 제작, 유통 등록 과정을 거쳐 출간됩니다. 세부 일정은 도서의 장르, 분량, 제작 난이도, 출간 계획에 따라 달라질 수 있습니다.`
  },
  {
    id: "q21",
    question: "출간 일정은 어떻게 정해지나요?",
    answer: `출간 일정은 원고 완성도, 편집 일정, 디자인 확정 일정, 제작 일정, 마케팅 계획, 출판사의 전체 출간 일정 등을 고려해 정합니다. 
            저자의 원고 제출과 피드백 속도도 전체 일정에 영향을 줄 수 있습니다.`
  },
  {
    id: "q22",
    question: "종이책과 전자책을 함께 출간할 수 있나요?",
    answer: `도서의 성격과 출간 전략에 따라 종이책, 전자책, 오디오북 등 다양한 포맷으로 출간할 수 있습니다. 
            어떤 매체로 출간할지는 계약 범위와 출간 전략에 따라 정합니다.`
  },
  {
    id: "q23",
    question: "의견이 다를 때는 어떻게 조율하나요?",
    answer: `의견 차이가 있을 경우 담당 편집자와 저자가 먼저 충분히 협의합니다. 필요한 경우 편집 책임자나 기획 담당자가 함께 논의해 출간 방향을 조정합니다. 
            기획 출판에서는 저자의 의도와 출판사의 시장 판단을 함께 고려해, 책의 완성도와 독자 전달력을 높이는 방향으로 조율합니다.`
  },
  {
    id: "step",
    header: "유통·판매 및 정산"
  },
  {
    id: "q24",
    question: "기획 출판 도서는 어디에서 판매되나요?",
    answer: `기획 출판 도서는 출판사의 유통망을 통해 주요 온라인 서점, 오프라인 서점, 전자책 플랫폼 등에 판매될 수 있습니다. 
            유통 채널은 도서의 성격과 출간 매체에 따라 달라질 수 있습니다.`
  },
  {
    id: "q25",
    question: "오프라인 서점에도 진열될 수 있나요?",
    answer: `오프라인 서점 진열은 출판사의 유통 활동과 서점의 판단, 도서의 성격, 판매 흐름 등에 따라 달라집니다. 
            출판사가 유통을 진행하더라도 모든 서점의 진열이 보장되는 것은 아니며, 도서 특성과 판매 전략에 따라 진열 가능성을 검토합니다.`
  },
  {
    id: "q26",
    question: "책의 정가는 어떻게 정해지나요?",
    answer: `정가는 제작비, 유통 조건, 경쟁 도서 가격, 독자층, 시장 포지션 등을 고려해 출판사가 결정합니다.
             필요한 경우 저자와 협의할 수 있습니다.`
  },
  {
    id: "q27",
    question: "판매 실적과 인세 정산은 어떻게 확인하나요?",
    answer: `판매 실적과 인세 정산은 계약에서 정한 기준과 정산 주기에 따라 확인할 수 있습니다. 
            정산 자료 제공 방식과 세부 항목은 유통 채널, 계약 조건, 도서의 판매 형태에 따라 달라질 수 있습니다.`
  },
  {
    id: "q28",
    question: "판매가 기대에 미치지 못할 경우 어떻게 대응하나요?",
    answer: `판매가 기대에 미치지 못할 경우 출판사는 원인을 분석하고, 도서 소개 문구, 광고·홍보 채널, 프로모션, 유통 전략 등을 조정할 수 있습니다. 
            다만 판매 성과는 시장 상황, 독자 반응, 저자의 홍보 참여, 출간 시기 등 다양한 요인에 영향을 받습니다.`
  },
  {
    id: "q29",
    question: "Amazon KDP를 통한 해외 판매도 가능한가요?",
    answer: `계약 범위에 따라 Amazon KDP 출간을 에이콘을 통해 진행할 수 있습니다. 
            Amazon KDP를 활용하면 전자책 또는 종이책 주문형 인쇄(POD) 방식으로 해외 독자에게 판매할 수 있습니다. 
            다만 번역 여부, 제작 방식, 판매 국가, 정산 기준 등은 도서의 성격과 출간 목적에 따라 별도 협의가 필요합니다.`
  },
  {
    id: "step",
    header: "마케팅 및 홍보"
  },
  {
    id: "q30",
    question: "마케팅은 어떻게 진행되나요?",
    answer: `기획 출판에서는 출판사가 도서의 성격과 독자층을 고려해 마케팅 전략을 수립하고, 온라인 서점용 도서 정보 작성, 도서 소개 자료 작성, 보도자료, SNS 홍보, 프로모션 등을 진행합니다.`
  },
  {
    id: "q31",
    question: "저자는 어떤 방식으로 마케팅에 참여할 수 있나요?",
    answer: `저자는 인터뷰, 기고, 강연, 북토크, SNS 홍보, 독자와의 소통 등에 참여할 수 있습니다. 
            저자의 전문성과 활동 기반이 책의 주제와 잘 연결될수록 독자에게 책을 알리는 데 도움이 됩니다.`
  },
  {
    id: "q32",
    question: "마케팅 결과는 어떻게 점검하나요?",
    answer: `판매량, 온라인 서점 반응, 검색량, 리뷰, SNS 언급, 언론 노출, 행사 반응 등을 바탕으로 마케팅 결과를 점검할 수 있습니다. 
            필요한 경우 성과 분석 결과에 따라 홍보 메시지나 채널을 조정할 수 있습니다.`
  },
  
  {
    id: "step",
    header: "사후 관리"
  },
  {
    id: "q33",
    question: "출간 후 어떤 관리가 이루어지나요?",
    answer: `출간 후에는 판매 현황 확인, 정산, 유통 상태 점검, 독자 반응 모니터링, 마케팅 후속 지원, 재고 관리 등이 이루어질 수 있습니다. 
            제공 범위는 도서의 성격과 출판사의 운영 방식에 따라 달라집니다.`
  },
  {
    id: "q34",
    question: "증쇄는 언제 검토하나요?",
    answer: `증쇄는 재고 소진 속도, 판매 추이, 유통 요청, 시장 반응 등을 고려해 검토합니다. 
            저자와 협의가 필요한 경우에는 증쇄 일정과 수량, 수정 사항 등을 함께 검토합니다.`
  },
  {
    id: "q35",
    question: "개정판은 언제 검토하나요?",
    answer: `내용 업데이트가 필요하거나, 시장 반응이 좋고 장기 판매 가능성이 있다고 판단되는 경우 개정판을 검토할 수 있습니다. 
            전문서나 실용서의 경우 기술 변화, 제도 변화, 독자 피드백 등을 반영해 개정 여부를 판단합니다.`
  },
  {
    id: "q36",
    question: "절판은 어떤 기준으로 검토하나요?",
    answer: `절판은 판매 흐름, 재고 상황, 시장 변화, 개정 필요성, 계약 조건 등을 고려해 검토합니다. 중요한 결정은 저자와 협의해 진행할 수 있습니다.`
  },
  {
    id: "step",
    header: "권리 및 계약 유의사항"
  },
  {
    id: "q37",
    question: "저작권은 누구에게 있나요?",
    answer: `원고의 저작권은 원칙적으로 저작자에게 있습니다. 
            출판사는 계약에서 정한 범위 안에서 도서를 제작·출간·유통할 수 있는 권한을 갖습니다. 
            출판권, 전자책 발행 및 유통 권한, 오디오북, 해외 출간, 2차 저작물 등 세부 권리 범위는 계약 조건에 따라 정합니다.`
  },
  {
    id: "q38",
    question: "계약 기간은 어떻게 정하나요?",
    answer: `계약 기간은 도서의 성격과 계약 조건에 따라 정합니다. 계약 만료 후에는 판매 지속 여부, 계약 연장, 권리 반환 등을 협의합니다.`
  },
  {
    id: "q39",
    question: "2차 저작물 권리는 어떻게 관리하나요?",
    answer: `오디오북, 번역 출간, 해외 출간, 강의 콘텐츠, 영상화 등 2차 저작물 권리는 계약에서 별도로 정합니다. 
            출판사가 2차 저작물 기획·제작·유통에 참여하는 경우 수익 정산 기준도 함께 협의합니다.`
  },
  {
    id: "q40",
    question: "AI를 활용해 작성한 원고도 출간할 수 있나요?",
    answer: `AI를 활용해 작성한 원고도 출간 검토가 가능합니다. 다만 AI 도구를 사용한 경우에는 사용 여부와 활용 범위를 사전에 알려주셔야 합니다. AI 생성 문장, 이미지, 도표, 번역문 등은 저작권·표절·사실 오류 문제가 발생할 수 있으므로 출간 전 확인이 필요하며, 최종 원고에 대한 책임은 저작자에게 있습니다.

            또한 기획, 원고 작성, 편집, 번역, 이미지 생성 과정에서 AI를 일부 또는 전부 활용한 경우, 온라인 서점 전자책 등록 시 ‘AI 생성·활용 도서’임을 표기해야 할 수 있습니다. 단순한 본문 교정·교열, 표지 디자인 보조 활용 등은 적용 범위가 달라질 수 있으므로, AI 활용 여부와 범위는 출간 전 반드시 확인해 주시기 바랍니다.`
  },
  {
    id: "q41",
    question: "표절이나 저작권 침해 문제가 발생하면 어떻게 되나요?",
    answer: `원고 내용의 저작권 침해, 표절, 명예훼손, 초상권 침해 등 법적 문제가 발생할 경우 원칙적으로 저작자가 책임져야 합니다. 
            출판 과정에서 확인이 필요한 사항은 출판사와 협의해 검토할 수 있으며, 
            인용 자료, 이미지, 도표, 사진 등을 사용할 때는 출처와 사용 권한을 반드시 확인해야 합니다.`
  },
  {
    id: "step",
    header: "저자 포털 이용 안내"
  },
  {
    id: "q42",
    question: "저자 포털에서는 무엇을 확인할 수 있나요?",
    answer: `저자 포털에서는 계약 범위에 따라 출간 진행 상황, 유통 상태, 판매 및 정산 자료, 도서 정보 등을 확인할 수 있습니다. 
            제공 기능은 서비스 유형과 운영 범위에 따라 달라질 수 있습니다.`
  },
  {
    id: "q43",
    question: "저자 포털을 통해 정산 자료를 확인할 수 있나요?",
    answer: `저자 포털에서 판매 내역과 정산 정보를 확인할 수 있습니다. 
            자료 제공 시점과 세부 항목은 유통 채널의 정산 주기와 계약 조건에 따라 달라질 수 있으며, 필요한 경우 별도 정산 자료로 안내드릴 수 있습니다.`
  },
  {
    id: "q44",
    question: "포털 이용이 어려우면 어떻게 하나요?",
    answer: `포털 이용이 어려운 경우 이메일 문의를 통해 이용 방법을 안내받을 수 있습니다. 
            포털에서 제공되는 기능과 지원 범위는 계약 조건과 서비스 유형에 따라 달라질 수 있습니다.`
  },
  
  {
    id: "step",
    header: "상담 및 문의"
  },
  {
    id: "q45",
    question: "기획 출판 제안은 어떻게 접수하나요?",
    answer: `홈페이지 문의, 이메일, 전화 등을 통해 출간 제안을 할 수 있습니다. 
            도서 기획안, 목차, 샘플 원고, 저자 소개 자료를 함께 보내주시면 검토가 수월합니다.`
  },
  {
    id: "q46",
    question: "제안 전에 어떤 자료를 준비하면 좋나요?",
    answer: `저자 소개서, 도서 기획안, 목차, 샘플 원고, 예상 독자층, 경쟁 도서, 저자의 활동 이력, 홍보 가능성 등을 준비하면 좋습니다. 
            자료가 구체적일수록 출간 가능성과 적합한 출판 방식을 검토하기 쉽습니다.`
  },
  
];


const StepHeader = ({ header }) => (
  <div className="qa-step-header">
    <h4>{header}</h4>
  </div>
);

const QAItem = ({ id, question, answer, table, isOpen, onToggle }) => {
  const renderAnswer = () => {
    const answerContent = answer && (
      <p style={{ whiteSpace: "pre-line", marginBottom: table ? "1rem" : 0 }}>
        {answer}
      </p>
    );

    if (table) {      
      const lines = table.trim().split("\n");    
      const rows = lines
        .filter(line => line.trimStart().startsWith("|"))
        .map(line =>  
          line
            .trimStart()      
            .split("|")
            .slice(1, -1)
            .map(cell => cell.trim())
        );

      const [header, , ...body] = rows;

      return (
        <>
          {answerContent}
          <table className="qa-table">
            <thead>
              <tr>
                {header.map((cell, idx) => (
                  <th key={idx}>{cell}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {body.map((row, rIdx) => (
                <tr key={rIdx}>
                  {row.map((cell, cIdx) => (
                    <td key={cIdx}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </>
      );
    } else {
      return answerContent;
    }
  };


  return (
    <div className={`qa-card ${isOpen ? "open" : ""}`}>
      <div
        className="qa-card-question-header"
        onClick={() => onToggle(id)}
        role="button"
        aria-expanded={isOpen}
        aria-controls={`qa-answer-${id}`}
        tabIndex="0"
      >
        <h3>{question}</h3>
        <img
          src="./images/arrow-down.png"
          alt="Toggle dropdown"
          className="qa-card-arrow"
        />
      </div>
      <div
        id={`qa-answer-${id}`}
        className="qa-card-answer"
        aria-hidden={!isOpen}
      >
        {renderAnswer()}
      </div>
    </div>
  );
};

const QAPlanned = () => {
  const navigate = useNavigate();
  const [openFAQId, setOpenFAQId] = useState(null);

  const handleToggleFAQ = (id) => {
    setOpenFAQId((prevId) => (prevId === id ? null : id));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="qa-section-container">
        <div className="qa-section">          
          <div className="qa-section-header" >
            <button
              onClick={() => {
                navigate("/", { state: { scrollToFAQ: true } }); // 돌아갈 때 flag 전달
              }}
              className="carousel-nav-button prev"
              aria-label="Previous slide"
            >
              ❮
            </button>
            <h2>기획 출판 FAQ</h2>
          </div>
          <div className="qa-cards-container">
            {qaDataPlanned.map((qa, index) => {
              if (qa.id === "step") {
                return <StepHeader key={`step-${index}`} header={qa.header} />;
              }
              return (
                <QAItem
                  key={qa.id}
                  id={qa.id}
                  question={qa.question}
                  answer={qa.answer}
                  table={qa.table}
                  isOpen={openFAQId === qa.id}
                  onToggle={handleToggleFAQ}
                />
              );
            })}
          </div>                   
        </div>      
      </section>
      <Footer />
    </div>
  );
};

export default QAPlanned;
